import { PackageX, Truck } from "lucide-react";

const CreatorWaitingView = () => {
  return (
    <div className="w-full mx-auto py-2">
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-6">
        <div className="flex items-center gap-4">
          <div className="relative">
            <div className="absolute -inset-1">
              <div className="w-full h-full rotate-180 bg-purple-500 opacity-30 blur-sm rounded-full"></div>
            </div>
            <PackageX className="relative text-purple-600 size-6" />
          </div>

          <div className="flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-purple-900 font-semibold">
                Awaiting Product Delivery
              </h3>
              <div className="flex items-center gap-1.5 px-2.5 py-1 bg-purple-100 rounded-full">
                <span className="size-2 bg-purple-500 rounded-full animate-pulse"></span>
                <span className="text-xs font-medium text-purple-700">
                  In Transit
                </span>
              </div>
            </div>

            <div className="mt-3 flex items-center gap-2 text-purple-700">
              <Truck className="size-4" />
              <p className="text-sm">Product is on the way to creator</p>
            </div>
          </div>
        </div>

        <div className="mt-4 bg-white rounded-md border border-purple-100 p-3">
          <div className="flex items-start gap-3">
            <div className="size-2 bg-purple-400 rounded-full mt-1.5"></div>
            <div className="space-y-1">
              <p className="text-sm text-gray-700 font-medium">
                Delivery Status
              </p>
              <p className="text-sm text-gray-600">
                Creator has not yet received the product. Please allow some time
                for delivery.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatorWaitingView;
